import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ModalService } from '../shared/modal/modal.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';

import { AddCategoryComponent } from '../shared/modal/add-category/add-category.component'
import { UploadDocumentComponent } from '../shared/modal/upload-document/upload-document.component'
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';

import Utils from '../shared/utility';

@Component({
  selector: 'app-info-center',
  templateUrl: './info-center.component.html',
  styleUrls: ['./info-center.component.css']
})
export class InfoCenterComponent implements OnInit {
  public healthCareMaterial: any[];
  public longTermCareMaterial: any[];
  public socialSecurityMaterial: any[];

  public articlesForClients: any[];
  public clientLetters: any[];
  public educationalWorkshops: any[];
  public factGuides: any[];
  public otherAdvertising: any[];
  public websiteArtwork: any[];

  public infoCenterArr: any[];

  public toggleInput: any;

  public selectedCategory: any;
  public selectedDescription: any;
  public selectedTitle: any;

  public selectedInputs: any = {};

  public error: any;

  public droppedData: any = {};

  public isEdit: boolean;
  public isEditDisable: boolean;

  // TODO: REMOVE THIS LATER
  public visible: boolean = false;

  public modalSubscription: any;

  constructor(private matDialog: MatDialog, private modalService: ModalService, private globalService: GlobalService, private snackBarService: SnackBarService) {
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'upload-docClosed') {
        this.getIC();
      }
    });
  }

  uploadDoc() {
    const categories = this.infoCenterArr.reduce((arr, item, i) => { arr.push({value: item.category, title: item.category, idx: i});  return arr }, []);
    this.modalService.add('upload-doc', { Data: { arr: this.infoCenterArr, section: 'info-center', categories }, ID: Number(localStorage.getItem("userId")) });
  }

  updateDoc(){
     this.editTextV2('title', this.selectedMaterial.item.Title, this.selectedMaterial.i, this.selectedMaterial.j, true);
    //use like: editTextV2('description', material.Description, i, j, false)
  }

  updateFileModal = false;
  updateSelectedFile(item, i, j){
    this.selectedMaterial = {
      item,
      i,
      j
    }
    this.updateFileModal = true;
  }

  deleteDoc() {
    this.infoCenterArr[this.selectedMaterial.i].items.splice(this.selectedMaterial.j, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.infoCenterArr);
    this.globalService.ReplaceInfoCenter(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Document has been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  public confirmDeleteVisible: boolean;
  public selectedMaterial: any;

  public categories: any;


  deleteItem(item, i, j) {
    this.selectedMaterial = {
      item,
      i,
      j
    }

    //this.confirmDeleteVisible = true;
    const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
      data: { title: 'Removing a Document', question: 'Are you sure you want to remove the document titled: <b>' + item.Title + '</b>?<br/><b>This cannot be undone</b>.' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.deleteDoc();
      }
    });
  }

  close() {
    this.confirmDeleteVisible = false;
  }

  enableUploadDoc: boolean = true;
  getIC() {
    this.globalService.GetInfoCenter()
      .subscribe(
        data => {
          let documents = Utils.convertMarketingMaterialOrInfoCenterToNewFormat(JSON.parse(data.data));
          
          let uniqueDocumentCategories = documents.reduce((obj, item) => {
            if (!obj[item.Category])
              obj[item.Category] = item.Category;
            return obj;
          }, {});

          this.categories = Object.keys(uniqueDocumentCategories).map((category, i) => category);

          this.infoCenterArr = [];
          this.droppedData = {};
          
          Object.keys(uniqueDocumentCategories).forEach((category, i) => {
            this.infoCenterArr.push({
              category: category,
              items: documents.filter(doc => doc.Category === category),
            });

            if (this.infoCenterArr[this.infoCenterArr.length - 1].items[0] && (!this.infoCenterArr[this.infoCenterArr.length - 1].items[0].Title || !this.infoCenterArr[this.infoCenterArr.length - 1].items[0].Description)) {
              if (this.infoCenterArr[this.infoCenterArr.length - 1].items.length > 1) {
                this.infoCenterArr[this.infoCenterArr.length - 1].items.splice(0, 1);
              }
            }
          });
          //console.log('IC ARRAY:', this.infoCenterArr);
          if(this.infoCenterArr.length == 0){
            this.enableUploadDoc = false;
          }

          this.generateSelectedInputs();
        },
        error => this.error = <any>error);

      
  }

  generateSelectedInputs() {
    this.selectedInputs = {};

    Object.keys(this.infoCenterArr).forEach((cat, i) => {
      this.selectedInputs[i] = { category: false }
    });

    this.infoCenterArr.forEach((cat, i) => {
      cat.items.forEach((doc, j) => {
        this.selectedInputs[i][j] = { title: false, description: false }
      });
    });
  }

  saveIC() {

    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.infoCenterArr);
    
    // this.globalService.ReplaceInfoCenter(oldFormat)
    //   .subscribe(
    //     resp => {
    //       if (resp) {
    //         this.snackBarService.add('Your document has been updated', 0);
    //       } else {
    //         this.snackBarService.add('An error occurred - please contact support', 1);
    //       }
    //       this.confirmDeleteVisible = false;
    //     },
    //     error => this.error = <any>error);
  }

  public userType: any;
  public rootLevelOrganization: boolean;

  ngOnInit() {
    this.userType = Number(localStorage.getItem('roleId')) || 3;
    this.visible = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.rootLevelOrganization = (Number(localStorage.getItem('parentID')) == 0) && (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2);

    this.toggleInput = {
      category: {},
      title: {},
      description: {},
    }

    this.getIC();
  }


  public addCategoryVisible: boolean = false;
  public newCategory: string = '';

  addCategory(category) {
    this.addCategoryVisible = true;
  }

  editCategory(catIdx, val) {

    const dialogRef = this.matDialog.open(AddCategoryComponent, {
      data: { docArr: this.infoCenterArr, value: val, type: 'marketing-material' }
    });

    dialogRef.afterClosed().subscribe(result =>{
      if(result.saved){
        if(result.delete){
          this.deleteCategory(val, catIdx);
        } else {
          this.selectedInputs[catIdx].category = false;
          this.infoCenterArr[catIdx].category = result.value;//this.selectedCategory;
          this.saveIC();
        }
      }
    });
  }

  deleteCategory(cat, index){
    this.selectedMaterial = {
      category: cat,
      index,
    }

    this.confirmCategoryDeleteVisible = true;
    this.infoCenterArr.splice(this.selectedMaterial.index, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.infoCenterArr);

    this.globalService.ReplaceInfoCenter(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Category and documents have been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          //this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  saveNewCategory() {
    this.infoCenterArr.unshift({
      category: this.newCategory.trim(), //.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }),
      items: [],
    });

    this.newCategory = '';
    this.generateSelectedInputs();
    this.closeCategoryWindow();
    this.saveIC();
  }

  closeCategoryWindow() {
    this.addCategoryVisible = false;
  }

  editTextV2(cat, val, catIdx, docIdx, isSaving) {
    if (isSaving) {
      if (cat === 'category') {
        this.selectedInputs[catIdx].category = false;
        this.infoCenterArr[catIdx].category = this.selectedCategory;
       // console.log('Selected Cat:', this.selectedCategory);
       // console.log('selecteed cat items:', this.infoCenterArr[catIdx].items);//this.infoCenterArr[this.selectedMaterial.i].items
      } else if (cat === 'title') {
        this.selectedInputs[catIdx][docIdx].title = false;
        this.infoCenterArr[catIdx].items[docIdx].Title = this.selectedTitle;
      } else if (cat === 'description') {
        this.selectedInputs[catIdx][docIdx].description = false;
        this.infoCenterArr[catIdx].items[docIdx].Description = this.selectedDescription;
      }
      this.saveIC();
    } else {
      if (cat === 'category') {
        this.selectedInputs[catIdx].category = true;
        this.selectedCategory = val;
      } else if (cat === 'title') {
        this.selectedInputs[catIdx][docIdx].title = true;
        this.selectedTitle = val;
      } else if (cat === 'description') {
        this.selectedInputs[catIdx][docIdx].description = true;
        this.selectedDescription = val;
      }
    }
  }

  onDrop(event, catIdx, docIdx) {

    if (!this.parentTableTriggered && catIdx === event.dropData.catIdx) {
      var fromDoc = this.infoCenterArr[event.dropData.catIdx].items[event.dropData.docIdx];
      var toDoc = this.infoCenterArr[catIdx].items[docIdx];
      this.infoCenterArr[event.dropData.catIdx].items[event.dropData.docIdx] = toDoc;
      this.infoCenterArr[catIdx].items[docIdx] = fromDoc;
    }

    this.parentTableTriggered = false;

    this.generateSelectedInputs();
    this.saveIC();
  }

  public parentTableTriggered: boolean = false;
  public triggeredIndex: any = 0;

  toggleModal(modalName): void {
    if (modalName == 'add-category') {
      const dialogRef = this.matDialog.open(AddCategoryComponent, {
        //width: '500px',
        //height: '300px',
        //data: this.categories,
        data: { docArr: this.infoCenterArr, type: 'info-center' }
      });
    }

    if (modalName == 'upload-document') {
      const dialogRef = this.matDialog.open(UploadDocumentComponent, {
        //width: '500px',
        //height: '700px',
        //data: this.categories,
        data: { categories: this.categories, docArr: this.infoCenterArr, type: 'info-center' }
      });

      dialogRef.afterClosed().subscribe(result =>{
        this.getIC();
      });
    }
  }

  onDropTable(event, catIdx, docIdx) {
    this.infoCenterArr[event.dropData.catIdx].items.splice(event.dropData.docIdx, 1);
    this.infoCenterArr[catIdx].items.push(event.dropData.item);

    if (!this.infoCenterArr[catIdx].items[0].Title || !this.infoCenterArr[catIdx].items[0].Description) {
      this.infoCenterArr[catIdx].items.splice(0, 1);
      this.parentTableTriggered = true;
    }

    this.generateSelectedInputs();
    this.saveIC();
  }

  public confirmCategoryDeleteVisible: boolean = false;

  removeCategory(cat, index) {
    this.confirmCategoryDeleteVisible = true;
    this.selectedMaterial = {
      category: cat,
      index,
    }
  }

  // deleteCategory(){
  //   this.confirmCategoryDeleteVisible = true;
  //   this.infoCenterArr.splice(this.selectedMaterial.index, 1);
  //   const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.infoCenterArr);
  //   this.closeCategoryDelete();

  //   this.globalService.ReplaceInfoCenter(oldFormat)
  //   .subscribe(
  //     resp => {
  //       if (resp) {
  //         this.snackBarService.add('Your category and documents have been updated', 0);
  //       } else {
  //         this.snackBarService.add('An error occurred - please contact support', 1);
  //       }
  //       this.confirmDeleteVisible = false;
  //     },
  //     error => this.error = <any>error);

  // }

  closeCategoryDelete() {
    this.confirmCategoryDeleteVisible = false;
  }
}

